import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-doing",
  "use": "icon-doing-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-doing\"><path d=\"M512 0C229.233778 0 0 229.233778 0 512s229.233778 512 512 512 512-229.233778 512-512S794.766222 0 512 0z m306.048 622.165333H437.347556v-10.311111h-3.825778V231.153778h64.725333v326.300444H818.062222v64.711111z\" fill=\"#40c9c6\" p-id=\"5389\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol